// A new publication or proposal from an Otable document (.otable — exported from Otable's writer; the
// format: docs/otable-document-format.md). The document is created as any other (POST /proposal/proposals/, so the
// same permissions and defaults apply), then filled from the file with the writer's import (replace mode:
// backend proposal/proposal/otable_transfer.py). If the file can't be imported, the empty document is removed again.
import { axiosService } from 'shared/helpers/axios';

export const OTABLE_EXTENSION = '.otable';
export const OTABLE_ACCEPT = '.otable,application/vnd.otable.document+zip';

export const isOtableFile = (file) => Boolean(file?.name?.toLowerCase().endsWith(OTABLE_EXTENSION));

const errorText = (err) => err?.response?.data?.error || err?.response?.data?.detail || err?.message || 'The file could not be imported.';

/** createPayload: the body for POST /proposal/proposals/. Returns { proposal, result } or throws Error(message). */
export async function createFromOtableFile(file, createPayload) {
  if (!isOtableFile(file)) throw new Error(`Choose an Otable document (${OTABLE_EXTENSION}).`);
  const stem = file.name.replace(/\.otable$/i, '').replace(/[-_]+/g, ' ').trim();
  const created = await axiosService.post('/proposal/proposals/', { title: stem || 'Imported document', ...createPayload });
  const proposal = created.data;
  try {
    const form = new FormData();
    form.append('file', file);
    form.append('mode', 'replace');
    const res = await axiosService.post(`/proposal/proposals/${proposal.id}/import_publication_docx/`, form, { timeout: 180000 });
    return { proposal, result: res.data };
  } catch (err) {
    await axiosService.delete(`/proposal/proposals/${proposal.id}/`).catch(() => {});
    throw new Error(errorText(err));
  }
}
